export const focusableElements = 'a[href], button, input, textarea, select, details, [tabindex]';
